import {inject, Injectable} from "@angular/core";
import {OccCartAdapter} from "@spartacus/cart/base/occ";
import {Observable} from "rxjs";
import {Cart, CART_NORMALIZER} from "@spartacus/cart/base/root";
import {HttpParams} from "@angular/common/http";
import {map} from "rxjs/operators";
import {FeatureConfigService, Occ} from "@spartacus/core";
import SaveCartResult = Occ.SaveCartResult;

@Injectable()
export class GonvarriCartAdapter extends OccCartAdapter {

  private gonvarriFeatureConfigService = inject(FeatureConfigService);

  saveAndClone(
    userId: string,
    cartId: string,
    saveCartName: string,
    saveCartDescription: string,
    cloneCart: boolean
  ): Observable<Cart> {

    let endpoint = this.occEndpointsService.buildUrl('saveCart', {
      urlParams: {
        userId,
        cartId,
        saveCartName,
        saveCartDescription
      },
    });

    endpoint = endpoint + "&cloneCart="+cloneCart;

    let httpParams: HttpParams = new HttpParams();

    if (
      this.gonvarriFeatureConfigService?.isEnabled(
        'occCartNameAndDescriptionInHttpRequestBody'
      )
    ) {
      httpParams = httpParams
        .set('saveCartName', saveCartName)
        .set('saveCartDescription', saveCartDescription)
        .set('cloneCart', cloneCart);
    }

    return this.http.patch<Occ.Cart>(endpoint, httpParams).pipe(
      map((cartResponse) => (cartResponse as SaveCartResult).savedCartData),
      this.converterService.pipeable(CART_NORMALIZER)
    );
  }

}
